import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, TextField, useEntityManager, Checkbox } from 'elentari'
import mercadoriaRepository from './MercadoriaRepository'
import EmpresaSelect from '../Empresa/EmpresaSelect'
import { RiscoAutocomplete } from '../Riscos/components'
import { validateForm } from './validation'

const MercadoriaForm = props => {
  const entityManager = useEntityManager({ repository: mercadoriaRepository })
  return (
    <CrudForm {...props} {...entityManager} validate={validateForm} withPaper>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Field
            fullWidth
            disabled
            name="descricao"
            label="Descrição"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            fullWidth
            disabled
            name="descricaoResumida"
            label="Descrição Resumida"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            fullWidth
            name="riscoId"
            label="Risco"
            component={RiscoAutocomplete}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EmpresaSelect disabled />
        </Grid>
        <Grid item xs={12} md={4}>
          <Field
            fullWidth
            name="ativo"
            label="Ativo"
            component={Checkbox}
            type="checkbox"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Field
            fullWidth
            name="especifica"
            label="Específica"
            component={Checkbox}
            type="checkbox"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Field
            fullWidth
            name="mercadoriaBaixoValor"
            label="Mercadoria de Baixo Valor"
            component={Checkbox}
            type="checkbox"
          />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default MercadoriaForm
